import React from "react";
import styles from "./MyNotifications.module.css";
import NotificationFeed from "../NotificationFeed/NotificationFeed";

const MyNotifiationDropdown = () => {
  return (
    <div className={`${styles.notificationModal} ${styles.noSelect}`}>
      <div className={styles.notificationModal__Header}>
        <h1 className={styles.notificationModal__Heading}>Notifications</h1>
      </div>
      <NotificationFeed isModal />
    </div>
  );
};

export default MyNotifiationDropdown;
